import { useContext, useEffect, useState } from "react";
import Tabs from "../../components/Tabs";
import Users from "./users";
import Auctions from "./auctions";
import Categories from "./categories";
import { useLocation, useNavigate } from "react-router-dom";
import { LoggedInUserContext } from "../../context/loggedInUserContext";
import { Roles } from "../../types/role.enums";
const Admin = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const location = useLocation();
  const { loggedInUserContext } = useContext(LoggedInUserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (loggedInUserContext?.role.name === Roles.SUPER_ADMIN)
      navigate("/admin");
    else navigate("/");
  }, []);
  useEffect(() => {
    if (location?.state?.selectedTab === 3)
      setSelectedTab(
        !location?.state?.selectedTab ? 0 : location?.state?.selectedTab
      );
    else setSelectedTab(0);
  }, []);
  const [tabs] = useState<string[]>([
    "Users",
    "Auctions",
    // "Settings",
    "Categories",
  ]);
  const RenderComponent = (tab: number) => {
    switch (tab) {
      case 0:
        return <Users />;
      case 1:
        return <Auctions />;
      case 2:
        return <Categories />;
      default:
        <Users />;
    }
  };
  return (
    <div className="flex justify-center items-center flex-col">
      <h1 className="text-center">Admin Control Panel</h1>
      <Tabs
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={tabs}
      />
      <div className="mt-5">{RenderComponent(selectedTab)}</div>
    </div>
  );
};

export default Admin;
